import axios, { AxiosRequestConfig } from 'axios'
import { message } from 'ant-design-vue'
import { getToken, removeToken } from '@/utils/auth'
import globalConfig from './config'
import router from '@/router'

const service = axios.create({
  baseURL: globalConfig.baseUrl,
  timeout: 15000,
})

// 防止登录过期弹多次
let isRedirectingToLogin = false

function redirectToLogin() {
  if (isRedirectingToLogin) return
  isRedirectingToLogin = true
  removeToken()
  router.replace('/login').finally(() => {
    isRedirectingToLogin = false
  })
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['t'] = token
      config.headers['source'] = 'admin'
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // blob 响应直接返回
    if (response.config.responseType === 'blob' || res instanceof Blob) {
      return res
    }

    // 登录过期
    if (res.code === '402') {
      redirectToLogin()
      return Promise.reject(new Error(res.message || '登录已过期'))
    }

    // 业务错误
    if (res.code !== '200') {
      message.error(res.message || '请求失败')
    }

    return res
  },
  error => {
    const status = error.response?.status
    if (status === 401 || status === 403) {
      redirectToLogin()
    } else {
      message.error(error.message || '网络异常，请稍后重试')
    }
    return Promise.reject(error)
  }
)

declare module 'axios' {
  interface AxiosInstance {
    (config: AxiosRequestConfig): Promise<any>
  }
}

export default service
